module.exports = __webpack_public_path__ + "Egencia.png?5ea5399ec19586b4646f7675b888560c";